import { InMemoryCache } from '@apollo/client';
import { ApolloClient } from 'apollo-client';
import Q from 'q';

import { getIetfLanguageTag } from 'js/lib/language';
import { tupleToStringKey } from 'js/lib/stringKeyTuple';
import user from 'js/lib/user';

import GetProductOwnership from 'bundles/entitlements-common/queries/GetProductOwnershipQuery.graphql';
import { formatGraphqlProductOnwership } from 'bundles/entitlements-common/utils/entitlementProductOwnershipUtils';
import CourseOwnerships from 'bundles/s12n-common/service/models/courseOwnerships';
import S12nOwnership from 'bundles/s12n-common/service/models/s12nOwnership';

export default (s12nId: string, rawData: boolean) => {
  const userId = user.get().id;
  const userProductItem = tupleToStringKey([userId, 'Specialization', s12nId]);
  const cache = new InMemoryCache();
  const client = new ApolloClient({
    uri: `/graphql-gateway?opname=GetProductOwnership`,
    cache,
    headers: {
      'Accept-Language': getIetfLanguageTag(),
    },
  });

  const promise = Q(
    client
      .query({
        query: GetProductOwnership,
        variables: {
          productOwnershipId: userProductItem,
        },
        context: { clientName: 'gatewayGql' },
      })
      .then(({ data }) => {
        return {
          elements: [formatGraphqlProductOnwership(data?.Entitlement?.queryProductOwnership)],
        };
      })
  ) as Q.Promise<any>;

  promise
    .then((data: $TSFixMe) => {
      // TODO(grace): Once courseOwnerships are returned as a linked field instead of an attribute,
      // inflate s12nCourseOwnerships using createLinkedModels instead.
      let s12nData = data.elements[0];
      const s12nCourseOwnerships = s12nData.s12nCourseOwnerships;

      if (rawData) {
        s12nData = Object.assign({}, s12nData, {
          s12nCourseOwnerships: s12nCourseOwnerships || [],
        });

        return s12nData;
      }

      s12nData = Object.assign({}, s12nData, {
        s12nCourseOwnerships: new CourseOwnerships(s12nCourseOwnerships || []),
      });

      return new S12nOwnership(s12nData);
    })
    .fail(() => {
      if (rawData) {
        return {
          id: tupleToStringKey([userId, s12nId]),
          userId,
          productId: s12nId,
          s12nCourseOwnerships: {},
        };
      }

      return new S12nOwnership({
        id: tupleToStringKey([userId, s12nId]),
        userId,
        productId: s12nId,
        s12nCourseOwnerships: new CourseOwnerships(),
      });
    });

  promise.done();
  return promise;
};
